import React from "react";
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import {Button, Container} from "reactstrap";

export default function Page404() {
    return (<Container className="text-center mt-5">
        <Helmet>
            <title>Страница не найдена | iCandy</title>
        </Helmet>
        <h1>Страница не найдена</h1>
        <p className="text-muted mb-4">Такой страницы нет. Возможно, она была удалена или ссылка неверна.</p>
        <Link to="/">
            <Button color="primary" size="lg">На главную</Button>
        </Link>
    </Container>)
}